'use client';
import React, { useState } from 'react';

interface FAQItem {
  id: number;
  question: string;
  answer: string;
}

const faqItems: FAQItem[] = [
  {
    id: 1,
    question: 'Is PlotAE open to individual buyers or end users?',
    answer:
      'PlotAE is a B2B platform tailored for professionals. However, serious individual investors are welcome to enquire, and our team will assist based on project suitability and requirements.',
  },
  {
    id: 2,
    question: 'How does PlotAE ensure listings are genuine?',
    answer:
      'All listings on PlotAE go through a rigorous verification process. We cross-check with Dubai Land Department (DLD) records and work only with verified sellers and agents to ensure authenticity and accuracy of every listing.',
  },
  {
    id: 3,
    question: 'What kind of land parcels are listed on PlotAE?',
    answer:
      'PlotAE lists a wide variety of land parcels including residential plots, commercial plots, industrial plots, mixed-use land, and hospitality development plots across Dubai, Abu Dhabi, Ras Al Khaimah, and other UAE emirates.',
  },
  {
    id: 4,
    question: 'Is PlotAE suitable for overseas investors?',
    answer:
      'Absolutely. PlotAE is designed to serve both local and international investors. Our team provides comprehensive support including virtual tours, documentation assistance, and legal guidance to make cross-border investments seamless.',
  },
  {
    id: 5,
    question: 'Do you assist in closing the transaction?',
    answer:
      'Yes, PlotAE offers end-to-end transaction support. From initial inquiry and site visits to due diligence, negotiation, and final documentation, our specialist team is with you every step of the way.',
  },
];

export default function FAQSection() {
  const [openItem, setOpenItem] = useState<number | null>(1);

  const toggleItem = (id: number) => {
    setOpenItem(openItem === id ? null : id);
  };

  return (
    <section className="py-12 bg-white">
      <div className="max-w-[1280px] mx-auto px-4 lg:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Left: FAQ Title */}
          <div>
            <h2 className="text-[48px] font-bold text-[#1a1a1a] leading-none">FAQ</h2>
          </div>

          {/* Right: FAQ Items */}
          <div className="lg:col-span-3">
            <div className="divide-y divide-gray-200">
              {faqItems.map((item) => (
                <div key={item.id} className="py-4">
                  <button
                    onClick={() => toggleItem(item.id)}
                    className="w-full flex items-center justify-between text-left gap-4"
                  >
                    <span className="text-[15px] font-semibold text-[#1a1a1a]">
                      {item.question}
                    </span>
                    <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-[#017743] font-bold text-xl">
                      {openItem === item.id ? '−' : '+'}
                    </span>
                  </button>
                  {openItem === item.id && (
                    <div className="mt-3 pr-10">
                      <p className="text-[14px] text-[#50514f] leading-relaxed">{item.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
